// @flow

// Libs
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { push } from 'react-router-redux'

// Selectors
import { jobs$ } from 'hfty-soil-jobs'
import { default as reports$ } from '../selectors/reports'
import { default as reportsIsLoading$ } from '../selectors/loading'
import { default as errors$ } from '../selectors/errors'
import token$ from 'fc-auth/src/selectors/token'
import { default as selectedField$ } from '../selectors/selectedFieldId'
import { default as subHeader$ } from '../selectors/subHeader'

// Actions
import {
  loadLabResults,
  loadMapReports,
  downloadZip,
} from '../actions'

// Components
import Layout from '../components/Layout'

function mapStateToProps (state: Object): Props {
  return {
    jobs: jobs$(state),
    reports: reports$(state),
    reportsIsLoading: reportsIsLoading$(state),
    errors: errors$(state),
    token: token$(state),
    selectedField: selectedField$(state),
    subHeader: subHeader$(state),
  }
}

type MapDispatchToProps = {
  actions: {
    _redirect: Function,
    loadLabResults: Function,
    loadMapReports: Function,
    downloadZip: Function,
  }
}

function mapDispatchToProps (dispatch: Dispatch<*>): MapDispatchToProps {
  return {
    actions: bindActionCreators({
      _redirect: (url: string): Function => push(url),
      loadLabResults,
      loadMapReports,
      downloadZip,
    }, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Layout)
